import { render, staticRenderFns } from "./EditPassWord.vue?vue&type=template&id=c37efc98&scoped=true&"
import script from "./EditPassWord.vue?vue&type=script&lang=js&"
export * from "./EditPassWord.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c37efc98",
  null
  
)

export default component.exports